import { useApiCallStorageReader } from "../_base/useApiCallStorageReader";
import { useSharedStorage } from "../../../sharedStorage/useSharedStorage";
import apiClientOC from "icfrontendapiclient";
const bizApiErrorInterpreter = apiClientOC.get("BizApiErrorInterpreter");
const useCompAssessmentResultReader = (policy, customFormatResult = null, externalState) => {
  const [cloudAccountId] = useSharedStorage("cac_in_focus_cloud_account_id");
  const formatResult = async response => {
    // if the request failed, then return that response error
    if (bizApiErrorInterpreter.isError(response)) {
      return response;
    }
    let checkMapByCode = {};
    response.result.checks = response.result.checks.map(check => {
      // create a check code map so that we can get a check by its code
      // because the control list does not have checks, only associated check codes
      const checkCode = check.check_code;
      checkMapByCode[checkCode] = check;

      // add a helper text message field to each exception
      // this is used for example during delete exception to tell the user the exception won't be deleted until the next scan
      check.results = check.results.map(checkResult => {
        const message = {
          helper_text_display: ""
        };
        if (checkResult?.exception?.exception_as_of_assessment) {
          checkResult.exception.exception_as_of_assessment = {
            ...checkResult.exception.exception_as_of_assessment,
            ...message
          };
        }
        if (checkResult?.exception?.exception_as_of_request) {
          checkResult.exception.exception_as_of_request = {
            ...checkResult.exception.exception_as_of_request,
            ...message
          };
        }
        if (checkResult?.exception?.other_exceptions) {
          checkResult.exception.other_exceptions = checkResult.exception.other_exceptions.map(checkResultException => {
            checkResultException = {
              ...checkResultException,
              ...message
            };
            return checkResultException;
          });
        }
        return checkResult;
      });
      return check;
    });
    const assessmentMeta = {
      assessment_state: response.result.assessment_state,
      assessment_state_dt: `${response.result.assessment_state_dt}Z`,
      next_assessment_start_dt: `${response.result.next_assessment_start_dt}Z`
    };
    let parsedResponse = {
      assessment_meta: assessmentMeta,
      check_map_by_code: checkMapByCode,
      control_list: response.result.controls,
      summary: response.result.compliance_summary
    };
    if (customFormatResult) {
      // apply custom format specific to the component sending the request
      // for example, used by delete exception to add a message in the response
      parsedResponse = await customFormatResult(parsedResponse, externalState);
    }
    return parsedResponse;
  };
  const [result, read, refresh] = useApiCallStorageReader({
    name: `complianceAssessmentResults_${policy}`,
    method: "get",
    path: "/cloud/assessment/latest/result",
    expireOn: {
      sharedStorageChangeList: ["cac_in_focus_cloud_account_id"],
      ttl_seconds: 10
    },
    formatResultFunc: formatResult
  });
  return [result, () => read({
    cloud_id: cloudAccountId,
    compliance_code: policy
  }), () => refresh({
    cloud_id: cloudAccountId,
    compliance_code: policy
  })];
};
export { useCompAssessmentResultReader };